module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/masyn-naegele-fed7c192b434ca4449ccc852b5f0b3e6.jpg";